import React from 'react';
import { Box } from '../../base/Box/Box';
import { SimpleHeaderAndTextTwoColSectionStoryblok } from '../../types/storyblok';
import { Type } from '../../base/Type/Type';
import Markup from '../../base/Markup/Markup';
import Link from '../../base/Link/Link';

export const SimpleHeaderAndTextTwoColSection = ({
  heading,
  text,
  linkTitle,
  link,
  alignment,
  colourScheme = 'white',
  overlayOverBkg,
}: SimpleHeaderAndTextTwoColSectionStoryblok) => {
  if (!heading && !text && !linkTitle && !link && !alignment) {
    return null;
  }

  return (
    <Box
      as="section"
      colourScheme={colourScheme || 'white'}
      blockSpacing
      bkg
      overlayOverBkg={overlayOverBkg}
    >
      <Box
        as="div"
        className="mx-auto flex max-w-standard flex-col gap-6 md:flex-row md:gap-10 lg:gap-15"
      >
        <Box as="div" className="md: basis-1/3">
          <Type as="h2" className="font-helvetica text-h2">
            {heading}
          </Type>
        </Box>
        <Box as="div" className="md: basis-2/3">
          <Markup content={text} className=" text-p1" />
          <Link href={link} variant="secondary" className="mt-10">
            {linkTitle}
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default SimpleHeaderAndTextTwoColSection;
